<div class="bg-white border-none rounded-[6px] shadow-sm mt-2">
  <nz-skeleton
    [ngClass]="loading ? 'p-3' : 'p-0'"
    [nzLoading]="loading"
    [nzActive]="true"
  ></nz-skeleton>
  <div
    class="flex flex-col lg:flex-row justify-between lg:items-center items-start"
  >
    <div class="p-3 flex items-center">
      <button class="border-none bg-transparent" (click)="back()">
        <img
          src="https://storage.googleapis.com/komerce/assets/icons/back.svg"
          alt=""
          width="40px"
        />
      </button>
      <span class="text-black text-[20px] font-semibold ml-[15px]"
        >Detail Balance</span
      >
    </div>
    <button
      class="bg-primary text-white me-3 ms-4 h-[40px] px-4 rounded hover:bg-opacity-90 inline-flex items-center"
      (click)="handleDownload()"
    >
      Download
    </button>
  </div>
  <hr />
  <div class="p-3 flex justify-between flex-wrap">
    <div
      class="lg:w-1/3 w-full border rounded flex flex-none items-center mb-2 lg:mb-0"
    >
      <span class="py-4 px-2 text-[18px]">Balance: </span>
      <span class="px-2 text-primary text-[18px] font-semibold">
        {{ balance.balance || 0 | idr }}
      </span>
    </div>
    <div
      class="d-flex justify-content-end flex-row flex-grow-1 gap-2 align-items-center mt-2"
    >
      <div class="d-flex align-items-center">
        <div class="form-group has-search d-flex align-items-center">
          <span class="form-control-feedback"
            ><i class="icon-search-normal-1"></i
          ></span>
          <input
            [(ngModel)]="filterHistory.airway_bill"
            (ngModelChange)="onChangeSearch($event)"
            type="text"
            class="form-control"
            placeholder="Receipt Number"
          />
        </div>
      </div>
      <div class="flex items-center">
        <div ngbDropdown class="inline-block relative">
          <button
            type="button"
            class="bg-primary px-3 py-2 rounded text-white"
            id="dropdownfilterorder"
            ngbDropdownToggle
          >
            <i class="icon-filter-search text-white"></i>
          </button>
          <div
            ngbDropdownMenu
            aria-labelledby="dropdownfilterorder"
            class="bg-white shadow-lg border rounded"
          >
            <button ngbDropdownItem disabled class="text-black font-bold">
              Filter
            </button>
            <div ngbDropdown placement="left" class="inline-block w-full">
              <button
                type="button"
                class="w-full px-4 py-2 hover:bg-gray-100 text-left"
                id="dropdownstatus"
                ngbDropdownToggle
              >
                Transaction Type
              </button>
              <div
                ngbDropdownMenu
                aria-labelledby="dropdownstatus"
                class="bg-white shadow-lg border rounded"
              >
                <button class="w-full text-left p-0">
                  <div
                    class="px-4 py-2 hover:bg-gray-100"
                    *ngFor="let list of status; let i = index"
                  >
                    <div class="flex items-center">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        (value)="(list.value)"
                        (id)="(list.id)"
                        (change)="getStatus($event, list)"
                        [checked]="list.checked"
                      />
                      <label
                        class="ml-2 text-[12px] whitespace-nowrap"
                        [for]="list.id"
                      >
                        {{ list.label }}
                      </label>
                    </div>
                  </div>
                </button>
              </div>
              <button
                type="button"
                class="btn w-100 px-4 ngx-daterangepicker-action"
                id="dropdownstatus"
                style="text-align: start"
                (click)="openDatepicker()"
              >
                Period
              </button>
              <div id="dropdownstatus">
                <input
                  type="text"
                  class="btn w-100"
                  ngxDaterangepickerMd
                  [(ngModel)]="selected"
                  [ngModelOptions]="{ standalone: true }"
                  [showCustomRangeLabel]="false"
                  [keepCalendarOpeningWithRange]="true"
                  [alwaysShowCalendars]="true"
                  [ranges]="ranges"
                  [linkedCalendars]="true"
                  [isInvalidDate]="isInvalidDate"
                  [showCancel]="true"
                  opens="center"
                  drops="down"
                  [locale]="setlocale"
                  (change)="onChangeDate($event)"
                  style="border: none; font-size: 14px; display: none"
                  #datePickerInput
                />
              </div>
              <div>
                <button
                  class="w-full px-4 py-2 text-primary text-left hover:bg-gray-100"
                  (click)="resetFilter()"
                >
                  Reset Filter
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="flex flex-col mt-3 w-full p-3 overflow-x-auto relative"
    (scroll)="onScroll($event)"
  >
    <table class="w-full border-collapse" style="z-index: 1">
      <thead class="sticky top-[-16px] bg-gray-50 h-[50px] z-10">
        <tr class="text-[16px]">
          <th scope="col" class="text-left px-4">Date</th>
          <th scope="col" class="text-left px-4">Transaction Type</th>
          <th scope="col" class="text-left px-4">Total</th>
          <th scope="col" class="text-left px-4">Balance</th>
          <th scope="col" class="text-left px-4">Action</th>
        </tr>
      </thead>
      <tbody *ngIf="HistoryList">
        <tr
          *ngFor="let items of HistoryList; let i = index"
          class="border-b hover:bg-gray-50 transition-colors"
        >
          <td class="px-4 py-3">
            <div class="flex flex-col">
              <div>{{ items.transaction_date | date : "dd MMMM yyyy" : "id-ID" }}</div>
              <div class="text-gray-500">{{ items.transaction_date.slice(10, -3) || "-" }} WIB</div>
            </div>
          </td>
          <td class="px-4 py-3">
            <div [ngSwitch]="items.transaction_type">
              <strong *ngSwitchCase="'top_up'">Topup Balance</strong>
              <div *ngSwitchCase="'payment_order'" class="flex flex-col">
                <strong>Payment Order</strong>
                <span class="text-gray-500 italic">{{ typeTransaction(items.payment_method) }}</span>
              </div>
              <div *ngSwitchCase="'generate_qris'" class="flex flex-col">
                <strong>QRISLY</strong>
                <span class="text-gray-500 italic">{{ typeTransaction(items.payment_method) }}</span>
                <span class="text-gray-500 italic">Generate QRIS</span>
              </div>
              <strong *ngSwitchDefault>
                {{ typePayment(items.payment_method) }}
                <span [ngClass]="classTransaction(items.transaction_type)">
                  ({{
                    typeTransaction(items.transaction_type)
                  }}) </span>
              </strong>
            </div>

            <div class="flex gap-4 mt-2">
              <img
                [src]="items.shipping_logo"
                alt=""
                [style.width.px]="
                  items.shipping_logo.includes('sicepat') ? 80 :
                  items.shipping_logo.includes('sap-express') ? 35 : items.shipping_logo.includes('gosend') ? 100 : 40
                "
              />
              <img
                *ngIf="items.shipping && items.awb"
                src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
                alt=""
                width="20px"
                [ngbPopover]="popContent"
                class="cursor-pointer"
              />
            </div>
            <ng-template #popContent>
              <div class="flex flex-col gap-1">
                <b>Receipt Number:</b>
                <div class="flex items-center gap-1">
                  <span class="w-[150px] truncate">
                    {{ items.awb }}
                  </span>
                  <button
                    class="p-0 border-none bg-transparent"
                    (click)="salinResi(items.awb); $event.stopPropagation()"
                  >
                    <img
                      class="ml-2 inline"
                      src="https://storage.googleapis.com/komerce/assets/icons/icons-copy.svg"
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </ng-template>
          </td>
          <td class="px-4 py-3">
            <div [ngClass]="items.type === 'debit' ? 'text-red-500' : 'text-green-500'">
              {{ items.type === 'debit' ? '-' : '+' }} {{ items.nominal | idr }}
            </div>
          </td>
          <td class="px-4 py-3">
            <div>{{ items.balance | idr }}</div>
          </td>
          <td class="px-4 py-3">
            <div *ngIf="items.reference_transaction_id && !['withdrawal', 'top_up', 'payment_order', 'generate_qris'].includes(items.transaction_type); else noAction">
              <a [routerLink]="['/order-data/order-detail', items.reference_transaction_id]">
                <button class="text-primary hover:underline font-medium">See Detail</button>
              </a>
            </div>
            <ng-template #noAction><div>-</div></ng-template>
          </td>
        </tr>
      </tbody>
      <tbody *ngIf="HistoryList === null">
        <tr>
          <td colspan="5" class="py-10 text-center">
            <nz-empty nzNotFoundImage="simple" [nzNotFoundContent]="contentTpl">
              <ng-template #contentTpl>
                <span>No Data</span>
              </ng-template>
            </nz-empty>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
